import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import {SupportButton} from "../SupportButton";
import {CouponSelector} from "../CouponSelector";
import React, {useRef} from "react";
import {Price} from "../../../../types/cart";
import {useAppSelector} from "../../../../hooks/hooks";
import {cartedProducts} from "../../../../store/cart/cartSlice";
import {useVoucherStore} from "../../../common/hooks/voucherStore";
import {useTranslation} from "react-i18next";

interface Args {
    totalPrice: Price,
    selectedCouponIdx: number | null,
    resetSalesCodeDiscount: (_: void) => void,
    setSelectedCouponIdx: (_: number | null) => void,
    setCouponDiscountAmount: (_: number) => void,
}

export function CouponDiscountField(
    {
        totalPrice,
        selectedCouponIdx,
        resetSalesCodeDiscount,
        setSelectedCouponIdx,
        setCouponDiscountAmount
    }: Args) {
    const { t } = useTranslation("order");
    const cartedProductList = useAppSelector(cartedProducts);
    const { couponCount} = useVoucherStore();
    const couponDiscountTitleRef = useRef<HTMLSpanElement>(null);

    return (
        <div className={style.supportPanel}>
            <div className={style.titleBar}>
                <h3 className={style.sectionTitle}>
                    <span ref={couponDiscountTitleRef}>{t("coupon.title")}</span>
                    <SupportButton
                        title={t("coupon.support.title")}
                        content={[t("coupon.support.desc1"),t("coupon.support.desc2"),
                            t("coupon.support.desc3"),t("coupon.support.desc4"),t("coupon.support.desc5"),
                        ]}
                        supportLeft={-(couponDiscountTitleRef.current?.getBoundingClientRect().width ?? 0)}
                    />
                </h3>
                <span className={style.couponCount}>
                    <span>{t("coupon.ownedCoupon")}&nbsp;</span>
                    <span className={style.count}>{couponCount}{t("coupon.unit")}</span>
                  </span>
            </div>
            <div className={style.selectorArea}>
                <CouponSelector
                    actualAmount={totalPrice.actualAmount}
                    products={cartedProductList ?? []}
                    changeSelectedCoupon={(couponIdx: number | null, totalDiscountAmount: number) => {
                        if (couponIdx) {
                            resetSalesCodeDiscount();
                        }
                        setSelectedCouponIdx(couponIdx);
                        setCouponDiscountAmount(totalDiscountAmount);
                    }}
                    selectedCouponIdx={selectedCouponIdx}
                />
            </div>
        </div>

    )
}